module.exports = __webpack_public_path__ + "static/media/sponcer_Insperity.e13a5bf5.png";